import type { SignalForm } from "@owanturist/signal-form";
import { useHandler } from "@suse-o11y/use-handler";
import { useEffect } from "react";
import { flushSync } from "react-dom";

export function usePropagateFocusWhenInvalid<TForm extends SignalForm>(
	form: undefined | TForm,
	beforePropagate: VoidFunction,
): void {
	const beforePropagateStable = useHandler(beforePropagate);

	useEffect(() => {
		return form?.onFocusWhenInvalid(() => {
			// enforce the component to re-render
			flushSync(() => beforePropagateStable());

			// at this point the component with invalid fields should already expand further and register new focus handler
			form.focusFirstInvalid();
		});
	}, [form, beforePropagateStable]);
}
